/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const t=(t,a,h)=>Math.min(Math.max(h,t),a);export{t as clamp};
//# sourceMappingURL=clamp.js.map
